import React from 'react';

import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import {
	createEditorPluginAIConfigItemMarkdown,
	type StatusLozengeType,
} from '../../../config-items/config-items';
import { sliceOrNodeToMarkdown } from '../../../config-items/slice-or-node-to-markdown';
import { streamConvoAI } from '../../../provider/prompt-requests/convo-ai';
import { Icon } from '../../assets/icons/brainstorm';
import { createInsertBelow, createReplace } from '../../config-item-actions/markdown';
import { isMinLength } from '../../config-item-visible/visibility-utils';
import { getExperimentalPlaceholderPromptConfiguration } from '../../experimental-placeholder-prompt-configuration';
import { getSlice } from '../utils';

const SELECTION_TYPE = 'range';

export const getExperimentalPromptPlaceholderConfigItemForRange = () => {
	const configurations = getExperimentalPlaceholderPromptConfiguration();

	if (configurations) {
		const statusLozengeType =
			configurations.statusType.toLowerCase() === 'new' ||
			configurations.statusType.toLowerCase() === 'beta'
				? (configurations.statusType.toLowerCase() as StatusLozengeType)
				: undefined;
		return {
			...configurations,
			configItem: createEditorPluginAIConfigItemMarkdown({
				key: CONFIG_ITEM_KEYS.EXPERIMENTAL_PROMPT_PLACEHOLDER,
				title: configurations.label,
				description: configurations.description,
				selectionType: SELECTION_TYPE,
				getInitialContext: ({ editorView, positions, intl, updateIdMap, mentionMap }) => {
					const selection = sliceOrNodeToMarkdown({
						slice: getSlice(editorView, positions),
						editorView,
						convertTo: 'markdown-plus',
						updateIdMap,
						selectionType: SELECTION_TYPE,
						mentionMap,
					});

					return {
						selection: selection.markdown,
						userLocale: intl.locale,
						intentSchemaId: 'shorten_intent_schema.json',
						contentStatistics: selection.contentStatistics,
					};
				},
				icon: ({ shownAt }) => <Icon shownAt={shownAt} />,
				triggerPromptRequest({ initialContext, editorSchema, analyticsContext }) {
					return streamConvoAI({
						aiSessionId: analyticsContext?.aiSessionId,
						userLocale: initialContext.userLocale,
						intentSchemaId: configurations.intent,
						editorSchema,
						fullDocument: initialContext.document,
						currentSelection: initialContext.selection,
					});
				},
				isVisible: ({ editorView, positions }) =>
					isMinLength({ editorView, minLength: 1, positions }),
				actions: [
					createInsertBelow({ appearance: 'secondary' }),
					createReplace({ appearance: 'primary' }),
				],
				getBackendModel: () => {
					return 'assistance-service';
				},
				statusLozengeType,
			}),
		};
	}
};
